import { Component, Vue } from 'vue-property-decorator';
import store from "Store/index";


@Component
export default class OrderingListUserMixin extends Vue 
{
    get isAdmin(): boolean {
        return this.isAdvancedAdmin || store.getters.orderingList.isUserAdvanced;
    }

    get isAdvancedAdmin(): boolean {
        return store.getters.orderingList.isUserAdvancedAdmin;
    }

    get isABCustomer(): boolean{
        if(store.state.auth.user && store.state.auth.user.extraInfo)
        {
            const customerType = store.state.auth.user.extraInfo.CustomerType;
            return customerType == 'A' || customerType == 'B';
        }
        return false;
    }

    get isABCCustomer(): boolean{
        if(store.state.auth.user && store.state.auth.user.extraInfo)
        {
            const customerType = store.state.auth.user.extraInfo.CustomerType;
            return customerType == 'A' || customerType == 'B' || customerType == 'C';
        }
        return false;
    }

    get isCCustomer(): boolean{
        if(store.state.auth.user && store.state.auth.user.extraInfo)
        {
            const customerType = store.state.auth.user.extraInfo.CustomerType;
            return customerType == 'C';
        }
        return false;
    }

    get isEmployee(){
        return store.getters.orderingList.isEmployee;
    }

    //if in the user hierarchy - the user is "allowed"
    get isAllowed(): boolean {
        return this.isAdvancedAdmin || this.isAdmin || this.isEmployee;
     }
}
